import { render, staticRenderFns } from "./CardSoftware.vue?vue&type=template&id=67c017cc&scoped=true&"
import script from "./CardSoftware.vue?vue&type=script&lang=js&"
export * from "./CardSoftware.vue?vue&type=script&lang=js&"
import style0 from "./CardSoftware.vue?vue&type=style&index=0&id=67c017cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c017cc",
  null
  
)

export default component.exports